/* ============================================================
   FlickerBet — Live Feed & Crash Multiplier Animations
   ============================================================ */ (function() {
    'use strict';
    // ── Animate crash multiplier ──
    const multiplierEl = document.querySelector('.crash-multiplier');
    if (multiplierEl) {
        let value = 1.0;
        let direction = 1;
        let speed = 0.02;
        const crashInterval = setInterval(function() {
            value += speed * direction;
            speed *= 1.01; // accelerate
            if (value >= 5.0) {
                // crash
                multiplierEl.textContent = "\uD83D\uDCA5 Crashed!";
                multiplierEl.style.color = 'var(--color-accent)';
                multiplierEl.style.textShadow = 'var(--glow-accent)';
                setTimeout(function() {
                    value = 1.0;
                    speed = 0.02;
                    multiplierEl.style.color = '';
                    multiplierEl.style.textShadow = '';
                }, 1500);
                return;
            }
            if (multiplierEl.textContent !== "\uD83D\uDCA5 Crashed!") multiplierEl.textContent = value.toFixed(2) + "\xd7";
        }, 100);
        // Clean up on page unload
        window.addEventListener('beforeunload', function() {
            clearInterval(crashInterval);
        });
    }
    // ── Animate hero phone multiplier ──
    const heroMult = document.querySelector('.feed-multiplier');
    if (heroMult) {
        let v = 1.0;
        const heroInterval = setInterval(function() {
            v += 0.03;
            if (v > 4.5) v = 1.0;
            heroMult.textContent = v.toFixed(2) + "\xd7";
        }, 200);
        window.addEventListener('beforeunload', function() {
            clearInterval(heroInterval);
        });
    }
    // ── Live feed activity simulation (dashboard) ──
    const feedItems = document.querySelectorAll('.dash-feed-item');
    if (feedItems.length) {
        const messages = [
            {
                text: '<strong>User #9341</strong> bet via AI feed',
                badge: 'won',
                label: 'Won $88'
            },
            {
                text: '<strong>Crash round</strong> started by AI',
                badge: 'live',
                label: 'Live'
            },
            {
                text: '<strong>847 users</strong> saw this moment',
                badge: 'ai',
                label: 'AI'
            },
            {
                text: '<strong>User #1122</strong> cashed out',
                badge: 'won',
                label: 'Won $340'
            },
            {
                text: '<strong>Prediction game</strong> generated',
                badge: 'ai',
                label: 'AI'
            }
        ];
        let msgIndex = 0;
        setInterval(function() {
            const item = feedItems[Math.floor(Math.random() * feedItems.length)];
            const msg = messages[msgIndex % messages.length];
            msgIndex++;
            const textEl = item.querySelector('.dash-feed-text');
            const badgeEl = item.querySelector('.dash-feed-badge');
            if (textEl && badgeEl) {
                item.style.opacity = '0';
                item.style.transition = 'opacity 0.3s ease';
                setTimeout(function() {
                    textEl.innerHTML = msg.text;
                    badgeEl.textContent = msg.label;
                    badgeEl.className = 'dash-feed-badge dash-feed-badge--' + msg.badge;
                    item.style.opacity = '1';
                }, 300);
            }
        }, 3500);
    }
})();

//# sourceMappingURL=project-6a06e5c63dd06d7c7d8222d4.9481b120.js.map
